export var ExchangeLiquidatorStatusEnum;
(function (ExchangeLiquidatorStatusEnum) {
    ExchangeLiquidatorStatusEnum["COMPLETED"] = "COMPLETED";
    ExchangeLiquidatorStatusEnum["INITIAL"] = "INITIAL";
    ExchangeLiquidatorStatusEnum["FAILED"] = "FAILED";
    ExchangeLiquidatorStatusEnum["PARTIAL"] = "PARTIAL";
})(ExchangeLiquidatorStatusEnum || (ExchangeLiquidatorStatusEnum = {}));
//# sourceMappingURL=exchange-liquidator-status.enum.js.map